import T from "prop-types";
import withCurrentUser from "MODULES/session/decorators/withCurrentUser";
import { TOOL_USED } from "MODULES/PurchaseOrders/constants";
import { Select } from "MODULES/shared/components/Forms";
import { properCase } from "LIB/formatters/text";
import { Field } from "redux-form";
import React from "react";

const ToolsUsedDropDown = ({
  currentUser,
  disabled,
  selectedLineItem,
  name = TOOL_USED,
  notRequired = false
}) => {
  const options = currentUser.tenant.tools_used.map(k => ({
    value: k,
    text: properCase(k).toUpperCase()
  }));

  return (
    <Field
      name={name}
      component={Select}
      options={options}
      label={properCase(TOOL_USED)}
      disabled={disabled}
      required={!selectedLineItem && !notRequired}
    />
  );
};

ToolsUsedDropDown.propTypes = {
  currentUser: T.shape({}).isRequired,
  disabled: T.bool,
  selectedLineItem: T.shape({}),
  notRequired: T.bool,
  name: T.string
};

export default withCurrentUser(ToolsUsedDropDown);



// WEBPACK FOOTER //
// ./app/modules/Locations/components/ToolsUsedDropDown.jsx